<template>
  <div>
    <div class="map-container">
      <div>
        <l-map
          ref="map"
          :zoom="zoom"
          :center="center"
          :options="{ zoomControl: false }"
          :maxZoom="18"
          :minZoom="2"
          id="mapArea"
        >
          <l-tile-layer :url="basemap.url"></l-tile-layer>
        </l-map>
      </div>
      <!--Sidebar-left-->
      <slide-x-left-transition>
        <div
          class="open-sidebar open-sidebar-left"
          v-show="!panel.sidebarLeft"
          @click="openSidebarLeft"
        >
          <arrow-right-icon />
        </div>
      </slide-x-left-transition>
      <slide-x-left-transition>
        <div class="sidebar-left" v-show="panel.sidebarLeft">
          <div
            class="closer-right mt-10px"
            @click="panel.sidebarLeft = !panel.sidebarLeft"
          >
            <close-icon :class="{ open: muni.show }" />
          </div>
          <search-by-keyword
            :geojson="geojson"
            :lmap="lmap"
            :initial="$route.query.name"
            v-if="geojson.features.length !== 0"
            v-on:input="createPopUp(feature)"
            v-model="feature"
          />
          <!--Sidebar-acordeon-->
          <div class="sidebar-container mt-20px">
            <div class="accordeon">
              <div
                class="accordeon-title cursor"
                @click="muni.show = !muni.show"
              >
                <div>Cherchez par municipalité</div>
                <div :class="{ open: !muni.show }"><close-icon-outline /></div>
              </div>
              <div class="small-line"></div>
              <div class="accordeon-body" v-show="muni.show">
                <label class="container-checkbox mt-20px"
                  >Toutes les villes
                  <input
                    type="checkbox"
                    value="Toutes les villes"
                    v-model="filters.municipalite"
                    @change="filterMap()" />
                  <span class="checkmark"></span
                ></label>
                <div v-if="options">
                  <div
                    v-for="(municipalite, index) in options.municipalite"
                    :key="index"
                  >
                    <label class="container-checkbox"
                      >{{ municipalite }}
                      <input
                        type="checkbox"
                        :value="municipalite"
                        v-model="filters.municipalite"
                        @change="filterMap()" />
                      <span class="checkmark"></span
                    ></label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="sidebar-container">
            <h2 class="section-title">Produits offerts</h2>
            <div class="double-dashed-border"></div>
            <div>
              <div>
                <div class="accordeon-title cursor">
                  <div>Produits transformés</div>
                  <div :class="{ open: !sidebarLeftSection.produits }">
                    <close-icon-outline
                      @click="
                        sidebarLeftSection.produits =
                          !sidebarLeftSection.produits
                      "
                    />
                  </div>
                </div>
                <div class="small-line"></div>
                <div class="accordeon-body">
                  <div v-if="options && sidebarLeftSection.produits">
                    <div
                      v-for="(
                        produits_transformes, index
                      ) in options.produits_transformes"
                      :key="index"
                    >
                      <label class="container-checkbox"
                        >{{ produits_transformes }}
                        <input
                          type="checkbox"
                          :value="produits_transformes"
                          v-model="filters.produits.produits_transformes"
                          @change="filterMap()" />
                        <span class="checkmark"></span
                      ></label>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div class="accordeon-title cursor">
                  <div>Oeufs et viandes</div>
                  <div :class="{ open: !sidebarLeftSection.oeufs }">
                    <close-icon-outline
                      @click="
                        sidebarLeftSection.oeufs = !sidebarLeftSection.oeufs
                      "
                    />
                  </div>
                </div>
                <div class="small-line"></div>
                <div class="accordeon-body">
                  <div v-if="options && sidebarLeftSection.oeufs">
                    <div
                      v-for="(
                        oeufs_et_viandes, index
                      ) in options.oeufs_et_viandes"
                      :key="index"
                    >
                      <label class="container-checkbox"
                        >{{ oeufs_et_viandes }}
                        <input
                          type="checkbox"
                          :value="oeufs_et_viandes"
                          v-model="filters.produits.oeufs_et_viandes"
                          @change="filterMap()" />
                        <span class="checkmark"></span
                      ></label>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div class="accordeon-title cursor">
                  <div>Fruits et légumes</div>
                  <div :class="{ open: !sidebarLeftSection.fruits }">
                    <close-icon-outline
                      @click="
                        sidebarLeftSection.fruits = !sidebarLeftSection.fruits
                      "
                    />
                  </div>
                </div>
                <div class="small-line"></div>
                <div class="accordeon-body">
                  <div v-if="options && sidebarLeftSection.fruits">
                    <div
                      v-for="(
                        fruits_et_legumes, index
                      ) in options.fruits_et_legumes"
                      :key="index"
                    >
                      <label class="container-checkbox"
                        >{{ fruits_et_legumes }}
                        <input
                          type="checkbox"
                          :value="fruits_et_legumes"
                          v-model="filters.produits.fruits_et_legumes"
                          @change="filterMap()" />
                        <span class="checkmark"></span
                      ></label>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div class="accordeon-title cursor">
                  <div>Produits artisanaux</div>
                  <div :class="{ open: !sidebarLeftSection.artisanaux }">
                    <close-icon-outline
                      @click="
                        sidebarLeftSection.artisanaux =
                          !sidebarLeftSection.artisanaux
                      "
                    />
                  </div>
                </div>
                <div class="small-line"></div>
                <div class="accordeon-body">
                  <div v-if="options && sidebarLeftSection.artisanaux">
                    <div
                      v-for="(
                        produits_artisanaux, index
                      ) in options.produits_artisanaux"
                      :key="index"
                    >
                      <label class="container-checkbox"
                        >{{ produits_artisanaux }}
                        <input
                          type="checkbox"
                          :value="produits_artisanaux"
                          v-model="filters.produits.produits_artisanaux"
                          @change="filterMap()" />
                        <span class="checkmark"></span
                      ></label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="sidebar-container">
            <h2 class="section-title">Lieux de ventes</h2>
            <div class="double-dashed-border"></div>
            <div>
              <div v-if="options" class="mt-20px">
                <div
                  v-for="(lieux_de_vente, index) in options.lieux_de_vente"
                  :key="index"
                >
                  <label class="container-checkbox"
                    >{{ lieux_de_vente }}
                    <input
                      type="checkbox"
                      :value="lieux_de_vente"
                      @change="
                        filterMap()
                        getDistribution()
                      "
                      v-model="filters.lieuxDeVente" />
                    <span class="checkmark"></span
                  ></label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </slide-x-left-transition>
      <!--Sidebar-right-->
      <slide-x-right-transition>
        <div
          class="open-sidebar open-sidebar-right"
          v-show="!panel.sidebarRight"
          @click="openSidebarRight"
        >
          <arrow-left-icon />
        </div>
      </slide-x-right-transition>
      <slide-x-right-transition>
        <div class="sidebar-right" v-show="panel.sidebarRight">
          <div
            class="closer-right mt-10px"
            @click="panel.sidebarRight = !panel.sidebarRight"
          >
            <close-icon />
          </div>
          <info-commerce
            v-if="sidebarRightSection.commerce"
            :selectedCommerce="selectedCommerce"
            :lmap="lmap"
          />
          <div v-if="!sidebarRightSection.commerce">
            <div v-if="businessIsSelected">
              <infoProducteur
                :selectedBusiness="selectedBusiness"
                :lmap="lmap"
                :distribution="distribution"
                :lieux="filters.lieuxDeVente"
              />
            </div>
            <div v-else>
              <div class="indication-sidebar">
                Cliquez sur une entreprise pour obtenir son information
              </div>
            </div>
          </div>
        </div>
      </slide-x-right-transition>
    </div>
  </div>
</template>
<script>
import searchByKeyword from './SearchKeyWord.vue'
import icon from '../assets/images/icon_map.png'
import L from 'leaflet'
import bounce from 'leaflet.smooth_marker_bouncing'
import axios from 'axios'
import infoProducteur from './InfoProducteur'
import infoCommerce from './InfoCommerce'
import methods from '../mixins/methods'
export default {
  data: function () {
    return {
      lmap: null,
      zoom: 9,
      center: [45.35, -73.6],
      basemap: {
        url: 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png'
      },
      panel: {
        sidebarLeft: true,
        sidebarRight: false
      },
      sidebarRightSection: {
        commerce: false
      },
      sidebarLeftSection: {
        produits: false,
        oeufs: false,
        fruits: false,
        artisanaux: false
      },
      muni: {
        show: false
      },
      businessIsSelected: false,
      selectedBusiness: {
        properties: null
      },
      selectedCommerce: {
        properties: null,
        businessAvailable: []
      },
      geojson: {
        type: 'FeatureCollection',
        features: []
      },
      filterGeojson: {
        type: 'FeatureCollection',
        features: []
      },
      distribution: {
        type: 'FeatureCollection',
        features: []
      },
      icon,
      bounce,
      options: null,
      windowWidth: window.innerWidth,
      filters: {
        municipalite: ['Toutes les villes'],
        produits: {
          produits_transformes: [],
          oeufs_et_viandes: [],
          fruits_et_legumes: [],
          produits_artisanaux: []
        },
        lieuxDeVente: []
      },
      feature: null,
      markers: []
    }
  },
  mixins: [methods],
  components: {
    searchByKeyword,
    infoProducteur,
    infoCommerce
  },
  methods: {
    showMap: function () {
      this.panel.sidebarLeft = false
      this.panel.sidebarRight = false
    },
    openSidebarLeft: function () {
      this.panel.sidebarLeft = true
      if (this.windowWidth < 992) {
        this.panel.sidebarRight = false
      }
    },
    openSidebarRight: function () {
      this.panel.sidebarRight = true
      if (this.windowWidth < 992) {
        this.panel.sidebarLeft = false
      }
    },
    getData: function () {
      axios
        .get('https://fousdurou.ca/index.php/wp-json/v1/geojson')
        .then((res) => {
          this.geojson.features = res.data
          this.addGeojsonToMap(this.geojson)
        })
    },
    addGeojsonToMap: function (geojson) {
      let vm = this
      // eslint-disable-next-line
      this.commerce = L.geoJSON(geojson, {
        pointToLayer: function (feature, latlng) {
          // eslint-disable-next-line
          return L.marker(latlng, {
            // eslint-disable-next-line
            icon: L.icon({
              iconUrl: icon,
              iconSize: [35, 35]
            })
          })
        },
        onEachFeature: function (feature, layer) {
          layer.on('click', function (e) {
            vm.$router.push('/?name=' + feature.properties.name)
            this.bounce(3)
            vm.createPopUp(feature)
          })
        }
      })
      let iconSuccursale = require('../assets/images/succursale.png')
      let iconSucc = L.icon({
        iconUrl: iconSuccursale,
        iconSize: [35, 35]
      })
      if (this.markers.length > 0) {
        this.markers.forEach((element) => {
          this.lmap.removeLayer(element)
        })
      }
      geojson.features.forEach((element) => {
        if (element.properties.point_de_service) {
          element.properties.point_de_service.forEach((element2) => {
            vm.markers.push(
              // eslint-disable-next-line
              new L.marker([element2.position.lat, element2.position.lng], {
                icon: iconSucc
              })
                .on('click', function (event) {
                  vm.$router.push('/?name=' + element.properties.name)
                  this.bounce(3)
                  vm.createPopUp(element)
                })
                .addTo(this.lmap)
            )
          })
        }
      })
      if (this.filters.lieuxDeVente.includes('Marchés publics')) {
        let theWholeThing = L.geoJSON(
          geojson.features.concat(this.distribution.features)
        )
        this.lmap.fitBounds(theWholeThing.getBounds().pad(Math.sqrt(2) / 2))
      } else {
        this.lmap.fitBounds(this.commerce.getBounds().pad(Math.sqrt(2) / 2))
      }

      this.commerce.addTo(this.lmap)
    },
    createPopUp (feature) {
      this.businessIsSelected = true
      this.openSidebarRight()
      this.sidebarRightSection.commerce = false

      this.selectedBusiness.properties = feature.properties
    },
    getOptions () {
      axios
        .get('https://fousdurou.ca/index.php/wp-json/v1/options')
        .then((res) => {
          this.options = res.data
        })
    },
    getDistribution () {
      if (this.lieux) {
        this.lmap.removeLayer(this.lieux)
      }
      let vm = this
      if (this.distribution.features.length === 0) {
        axios
          .get('https://fousdurou.ca/index.php/wp-json/v1/distribution')
          .then((res) => {
            this.distribution.features = res.data
          })
      }
      let iconCommerce = require('../assets/images/commerce.png')
      let iconMarket = require('../assets/images/pin_market.png')
      if (
        this.filters.lieuxDeVente.includes('Marchés publics') &&
        this.filters.lieuxDeVente.includes("Commerces d'alimentation")
      ) {
        this.lieux = L.geoJSON(this.distribution, {
          pointToLayer: function (feature, latlng) {
            // eslint-disable-next-line
            return L.marker(latlng, {
              // eslint-disable-next-line
              icon: vm.styleThisIcon(feature, iconMarket, iconCommerce)
            })
          },
          onEachFeature: function (feature, layer) {
            layer.on('click', function (e) {
              this.bounce(3)
              vm.createPopUpDistribution(vm, feature)
            })
          }
        }).addTo(this.lmap)
      } else if (this.filters.lieuxDeVente.includes('Marchés publics')) {
        let marches = this.distribution.features.filter(
          (element) => element.properties.type_commerce === 'Marché public'
        )
        this.lieux = L.geoJSON(marches, {
          pointToLayer: function (feature, latlng) {
            // eslint-disable-next-line
            return L.marker(latlng, {
              icon: L.icon({
                iconUrl: iconMarket,
                iconSize: [28, 35]
              })
            })
          },
          onEachFeature: function (feature, layer) {
            layer.on('click', function (e) {
              this.bounce(3)
              vm.createPopUpDistribution(vm, feature)
            })
          }
        }).addTo(this.lmap)
      } else if (
        this.filters.lieuxDeVente.includes("Commerces d'alimentation")
      ) {
        let commerce = this.distribution.features.filter(
          (element) =>
            element.properties.type_commerce === "Commerce d'alimentation"
        )
        this.lieux = L.geoJSON(commerce, {
          pointToLayer: function (feature, latlng) {
            // eslint-disable-next-line
            return L.marker(latlng, {
              // eslint-disable-next-line
              icon: L.icon({
                iconUrl: iconCommerce,
                iconSize: [28, 35]
              })
            })
          },
          onEachFeature: function (feature, layer) {
            layer.on('click', function (e) {
              this.bounce(3)
              vm.createPopUpDistribution(vm, feature)
            })
          }
        }).addTo(this.lmap)
      } else {
        if (this.lieux) {
          this.lmap.removeLayer(this.lieux)
        }
      }
    },
    styleThisIcon (feature, iconMarket, iconCommerce) {
      if (feature.properties.type_commerce === "Commerce d'alimentation") {
        return L.icon({
          iconUrl: iconCommerce,
          iconSize: [28, 35]
        })
      } else {
        return L.icon({
          iconUrl: iconMarket,
          iconSize: [28, 35]
        })
      }
    },
    unifyData (data, property) {
      let features = []
      let featuresTitle = []
      data.forEach((element) => {
        if (!featuresTitle.includes(element.properties[property])) {
          featuresTitle.push(element.properties[property])
          features.push(element)
        }
      })

      return features
    },
    filterMap () {
      if (this.commerce !== undefined) {
        this.commerce.remove()
      }
      let filterData = []
      this.filterGeojson = Object.assign({}, this.geojson)
      if (
        this.filters.municipalite.includes('Toutes les villes') ||
        this.filters.municipalite.length === 0
      ) {
        filterData = this.geojson.features
      } else {
        this.filters.municipalite.forEach((element) => {
          this.geojson.features.forEach((element2) => {
            if (
              element2.properties.municipalite !== '' &&
              element2.properties.municipalite !== null &&
              element2.properties.municipalite.length !== 0
            ) {
              if (element2.properties.municipalite.includes(element)) {
                filterData.push(element2)
              }
            }
          })
        })
      }
      this.filterGeojson.features = filterData
      filterData = []
      if (
        this.filters.produits.produits_transformes.length > 0 ||
        this.filters.produits.oeufs_et_viandes.length > 0 ||
        this.filters.produits.fruits_et_legumes.length > 0 ||
        this.filters.produits.produits_artisanaux.length > 0
      ) {
        Object.keys(this.filters.produits).forEach((element) => {
          if (this.filters.produits[element].lenght !== 0) {
            this.filters.produits[element].forEach((element2) => {
              this.filterGeojson.features.forEach((element3) => {
                if (
                  element3.properties[element] !== '' &&
                  element3.properties[element] !== null &&
                  element3.properties[element].length !== 0
                ) {
                  if (element3.properties[element].includes(element2)) {
                    filterData.push(element3)
                  }
                }
              })
            })
          }
        })
        if (filterData.length !== 0) {
          this.filterGeojson.features = filterData
        } else {
          this.filterGeojson.features = filterData
        }
      }

      let lieuxFilter = []
      this.filters.lieuxDeVente.forEach((element) => {
        this.filterGeojson.features.forEach((element2) => {
          if (element2) {
            if (element2.properties.lieux_de_vente.includes(element)) {
              lieuxFilter.push(element2)
            }
          }
        })
      })
      if (lieuxFilter.length !== 0) {
        this.filterGeojson.features = lieuxFilter
      }
      if (this.filterGeojson.features.length !== 0) {
        this.addGeojsonToMap(this.filterGeojson)
      } else {
        this.$toasted.show(
          'Cet agencement de filtres ne <br/> concorde avec aucune entreprise ',
          {
            theme: 'bubble',
            position: 'top-right',
            duration: 2000,
            className: 'color-toast-error'
          }
        )
      }
    }
  },
  mounted () {
    if (this.windowWidth < 992) {
      this.panel.sidebarLeft = false
    }
    this.$nextTick(() => {
      this.lmap = this.$refs.map.mapObject
      // eslint-disable-next-line
      L.control
        .zoom({
          position: 'topright'
        })
        .addTo(this.lmap)
    })
    this.getOptions()
    this.getData()
    this.getDistribution()
  }
}
</script>
<style>
.map-container {
  position: relative;
  height: calc(100vh - 160px);
  overflow: hidden;
}
#mapArea {
  height: 100vh;
  width: 100%;
}
.titre-carte {
  position: absolute;
  z-index: 1000;
  font-family: var(--font1);
  color: var(--color1);
  text-align: center;
  text-shadow: 2px 2px 0px white;
  width: 50%;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
}
.open-sidebar {
  background-color: var(--color1);
  width: 30px;
  height: 30px;
  padding: 15px;
  color: white;
  cursor: pointer;
}
.open-sidebar-left {
  position: absolute;
  top: 20%;
  left: 0;
  z-index: 2000;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}
.open-sidebar-right {
  position: absolute;
  top: 20%;
  right: 0;
  z-index: 1900;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
.sidebar-left {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 25%;
  background-color: white;
  z-index: 1000;
  overflow-y: auto;
  scrollbar-color: var(--color1) white !important;
  scrollbar-width: thin;
}
.sidebar-right {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 25%;
  background-color: white;
  z-index: 1000;
  overflow-y: auto;
  scrollbar-color: var(--color1) white !important;
  scrollbar-width: thin;
}
.indication-sidebar {
  color: var(--color1);
  font-family: var(--font1);
  font-size: 18px;
  text-align: center;
  margin-top: 60px;
}
.sidebar-right-element {
  font-family: var(--font1);
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: #707070;
}
.sidebar-right-element-dark {
  font-family: var(--font1);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: var(--color1);
  display: flex;
  align-items: center;
}
@media screen and (max-width: 992px) {
  .sidebar-left {
    width: 80%;
    z-index: 2000;
  }
  .sidebar-right {
    width: 80%;
    z-index: 2000;
  }
  .map-container {
    position: relative;
    height: calc(100vh - 80px);
    overflow: hidden;
  }
  .show-map-button {
    display: block;
    position: absolute;
    transform: translateX(-55%);
    top: 5px;
    left: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100000;
    font-family: var(--font1);
    color: var(--color2);
    background-color: white;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 5px;
    padding-bottom: 5px;
    border: 2px solid var(--color2);
    border-radius: 30px;
    cursor: pointer;
  }
  .show-map-button:active {
    border: 1px solid var(--color1);
    background-color: var(--color1);
    color: white;
  }
  .titre-carte {
    font-size: 19px;
    width: 75%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Map.vue